import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { queryClient } from '@/lib/react-query/queryClient';
import { authEndpoints } from '@/modules/auth/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';

export const useLogoutMutation = () => {
  return useMutation({
    mutationFn: () => fetchClient.POST(authEndpoints.logout),
    onSuccess: () => {
      const userQueryKey = usersQueryKeys.current();
      const prevUserState = queryClient.getQueryState(userQueryKey);

      if (prevUserState) {
        queryClient.setQueryData(userQueryKey, null);
      }

      const currentTenantQueryKey = companiesQueryKeys.currentTenant();
      const prevTenantState = queryClient.getQueryState(currentTenantQueryKey);

      if (prevTenantState) {
        queryClient.setQueryData(currentTenantQueryKey, null);
      }
    },
  });
};
